<script lang="ts">
  import UserBadge from '../components/values/UserBadge.svelte';
  import { UserService } from '../services/UserService.svelte';

  // -
  const User = $derived(UserService.body.user);
</script>

<aside class="LayoutUser">
  {#if User}
    <p class="user"><UserBadge user={User} show="name" compact={true} /></p>
  {/if}
</aside>

<style lang="scss">
  .LayoutUser {
    display: flex;
    align-items: center;
  }

  .user {
    display: flex;
    align-items: center;
    cursor: default;
    pointer-events: none;
  }
</style>
